import { render, staticRenderFns } from "./InspectionContent.vue?vue&type=template&id=40defa60&scoped=true"
import script from "./InspectionContent.vue?vue&type=script&lang=js"
export * from "./InspectionContent.vue?vue&type=script&lang=js"
import style0 from "./InspectionContent.vue?vue&type=style&index=0&id=40defa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40defa60",
  null
  
)

export default component.exports